<template>
    <div class="login-page">
        <main class="login-main">
            <header class="login-header">
                <img class="header-logo" src="@/assets/images/go_icon.png" width="105" alt="logo-img"/>
                <div class="header-signin">
                <span class="signin-text">Sign In</span>
                </div>
            </header>
            <section>
                <form id="login-form" class="login-form" >
                    <div class="form-group">
                        <input name="email" type="email" class="form-input form-control login-email" placeholder="Email" data-parsley-trigger="change" id="email" required/>
                    </div>
                    <div class="form-group">
                        <input name="pass" class="form-input form-control login-password" type="password" placeholder="Password" id="pass" required/>
                    </div>
                    <div class="form-group">
                        <button type="submit" class="form-btn btn btn-large bkg-green" @click="navigateToCampaign">Sign In</button>
                    </div>
                    <div class="form-group">
                        <label>
                            <input name="remember" type="checkbox" style="display:inherit" class="form-check" value="on" data-parsley-multiple="remember">  Remember me
                        </label>
                    </div>
                </form>
                <div class="login-register">
                <p class="register-question">Don't have an account?</p>
                <a class="register-link" href="mailto:moscoe-support@valtira.net">Request an account</a>
                </div>
            </section>
        </main>
    </div>
</template>

<script>
export default {
    name: 'SignInForm',
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {
        navigateToCampaign() {
            this.$router.push({path: '/campaignList'})
        }
    }

}
</script>

<style scoped src="@/assets/css/reset.min.css">

</style>
<style scoped src="@/assets/css/parsley.min.css">

</style>
<style scoped src="@/assets/css/main.css">

</style>
